module.exports = __webpack_public_path__ + "images/1067524.png";